import React, { useEffect, useState } from "react";
import { useTranslation } from "../../utils/useTranslation";
import { useNavigation, useRoute, RouteProp } from "@react-navigation/native";
import { default as Modal } from "../../components/custom/Modal";
import { headers } from "./utils/deliveryHeaders";
import { validSignedURLWithExt } from "../../utils/validateSignedUrl";

interface OrderItem {
  DocNum?: string;
  DocType?: string;
  ItemCode?: string;
  ProductGroup?: string;
  CustomerCode?: string;
  CustomerRef?: string;
  DeliveryAddress?: number;
  OrderDate?: number;
  RequestDate?: string;
  DelivrdQty?: string;
  OrderQty?: string;
  ShipToCode?: string;
  ShippingType?: string;
  State?: string;
  Warehouse?: string;
  SalesPerson?: string;
  SOOperator?: string;
  image?: string;
  PicturName?: string;
  Dscription?: string;
  Description?: string;
  FrgnName?: string;
}

interface RouteParams {
  order: OrderItem;
}

interface DeliveryDetailsScreenProps {
  order?: any;
  onBackPress?: () => void;
}

const DeliveryDetailsScreen = ({
  order: propOrder,
  onBackPress,
}: DeliveryDetailsScreenProps = {}) => {
  const route = useRoute<RouteProp<Record<string, RouteParams>, string>>();
  const routeOrder = route?.params?.order;
  const order = propOrder || routeOrder || {};
  const navigation = useNavigation();
  const [modalVisible, setModalVisible] = useState(true);
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState<any>(false);
  const { t } = useTranslation();

  useEffect(() => {
    // If the modal is dismissed (e.g. by tapping outside), we should trigger the back action
    if (!modalVisible) {
      if (onBackPress) {
        onBackPress();
      } else {
        if (navigation.canGoBack()) {
          navigation.goBack();
        }
      }
    }
  }, [modalVisible]);

  useEffect(() => {
    if (order?.PicturName) {
      validSignedURLWithExt(order.PicturName, "label", setIsImageLoading, setSelectedImage);
    } else {
      setIsImageLoading(false);
    }
  }, [order?.PicturName]);

  const ModalContent = (props: any) => {
    const _excludedKeys = [
      "BaseReference",
      "BatchAttribute1",
      "BatchAttribute2",
      "BatchAttribute3",
      "U_CashCusName",
      "U_CashCusPhone",
      "U_PMX_BAV1",
      "U_PMX_BAV2",
      "U_PMX_BAV3",
      "LastUpdate",
      "OrderQtyPCS",
      "SQRef.",
      "PaymentTerm",
      "RemainingQtyPCS",
    ];

    const _orderedKeys = [
      "DocNum",
      "DocType",
      "ItemCode",
      "ProductGroup",
      "CustomerCode",
      "CustomerRef",
      "DeliveryAddress",
      "OrderDate",
      "RequestDate",
      "DelivrdQty",
      "OrderQty",
      "RemainingQty",
      "ShipToCode",
      "ShippingType",
      "State",
      "Warehouse",
      "SalesPerson",
      "SOOperator",
    ];

    const _specialLabels = {
      DocNum: { oldLabel: "DocNum", newLabel: "documentNo" },
      DocType: { oldLabel: "Document", newLabel: "documentType" },
      ItemCode: { oldLabel: "ItemCode", newLabel: "itemCode" },
      ProductGroup: { oldLabel: "ProductGroup", newLabel: "productGroup" },
      CustomerCode: { oldLabel: "CustomerCode", newLabel: "customerCode" },
      CustomerRef: { oldLabel: "CustomerRef", newLabel: "customerRef" },
      DeliveryAddress: { oldLabel: "DeliveryAddress", newLabel: "deliveryAddress" },
      OrderDate: { oldLabel: "OrderDate", newLabel: "orderDate" },
      RequestDate: { oldLabel: "RequestDate", newLabel: "requestDate" },
      DelivrdQty: { oldLabel: "DelivrdQty", newLabel: "deliveryQty" },
      OrderQty: { oldLabel: "OrderQty", newLabel: "orderQty" },
      RemainingQty: { oldLabel: "RemainingQty", newLabel: "remainingQty" },
      ShipToCode: { oldLabel: "ShipToCode", newLabel: "shippingCode" },
      ShippingType: { oldLabel: "ShippingType", newLabel: "shippingType" },
      State: { oldLabel: "State", newLabel: "state" },
      Warehouse: { oldLabel: "Warehouse", newLabel: "warehouse" },
      SalesPerson: { oldLabel: "SalesPerson", newLabel: "sales" },
      SOOperator: { oldLabel: "SOOperator", newLabel: "operator" },
    };

    return (
      <Modal.ModalContent
        {...props}
        title={order?.ItemCode || ""}
        subTitle={order?.FrgnName || order?.Dscription || order?.Description || ""}
        icon="folder"
        uri={selectedImage}
        loading={isImageLoading}
        childern={
          <Modal.ModalBody
            listData={order || {}}
            excludedKeys={_excludedKeys}
            renameList={headers}
            orderedKeys={_orderedKeys}
            specialLabels={_specialLabels}
          />
        }
      />
    );
  };

  return (
    <Modal.ModalContainer
      modalVisible={modalVisible}
      setModalVisible={setModalVisible}
      childern={ModalContent}
    />
  );
};

export default DeliveryDetailsScreen;
